import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
} from "vee-validate";
import { rutValidator } from "../utils/validators/rutValidator";
import { cuitValidator } from "../utils/validators/cuitValidator";
import * as rules from "vee-validate/dist/rules";
import es from "vee-validate/dist/locale/es";
import en from "vee-validate/dist/locale/en";
localize({
  es,
  en,
});
for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: es.messages[rule], // add its message
  });
}

extend("rutValidation", {
  message: () => "El formato del campo RUT no es válido",
  validate: (value) => rutValidator(value),
});
extend("cuitValidation", {
  message: () => "El formato del campo CUIT no es válido",
  validate: (value) => cuitValidator(value),
});
// Register it globally
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
